import angular from 'angular';
// Layouts
import PageLayout from './common/pageLayout/pageLayout';
import PageLayoutSecondary from './common/pageLayoutSecondary/pageLayoutSecondary';

// Pages
import Home from './home/home';
import PhotosHomeLanding from './photosHomeLanding/photosHomeLanding';
import TrafficHomeLanding from './trafficHomeLanding/trafficHomeLanding';
import Traffic from './traffic/traffic';
import RegionSelectionLanding from './regionSelectionLanding/regionSelectionLanding';
import EnlargedLivefeed from './enlargedLivefeed/enlargedLivefeed';
import ClosingsDelaysLanding from './closingsDelaysLanding/closingsDelaysLanding';
import Videoplayer from './videoplayer/videoplayer';

// Shared Components
import WeatherHomeLanding from './weatherHomeLanding/weatherHomeLanding';
import RegionSelection from './common/regionSelection/regionSelection';
import Button from './common/news12Button/news12Button';
import PageLayoutWT from './common/pageLayoutWT/pageLayoutWT';
import LiveFeedVideo from './common/liveFeedVideo/liveFeedVideo';
import HeaderMain from './common/headerMain/headerMain';
import HeaderSecondary from './common/headerSecondary/headerSecondary';
import Navbar from './common/navbar/navbar';
import NavbarSubMenu from './common/navbarSubMenu/navbarSubMenu';
import StoryList from './common/storyList/storyList';
import NewsTicker from './common/newsTicker/newsTicker';
import Logo from './common/logo/logo';
import OtherRegions from './common/otherRegions/otherRegions';
import Poll from './common/poll/poll';
import WeatherIcons from './common/weatherIcons/weatherIcons';
import PhotoGallery from './common/photoGallery/photoGallery';
import News12List from './common/news12List/news12List';
import PhotoList from './common/photoList/photoList';
import IncidentList from './common/incidentList/incidentList';
import Archives from './common/archives/archives';
import Ads from './common/news12Ad/news12Ad';
import CameraList from './common/cameraList/cameraList';
import CameraGallery from './common/cameraGallery/cameraGallery';
import MapGallery from './common/mapGallery/mapGallery';
import Preroll from './common/preroll/preroll';

const componentModule = angular.module('app.components', [
  //-----------------------------------
  // Layouts
  //-----------------------------------
  PageLayout.name,
  PageLayoutSecondary.name, PageLayoutWT.name,
  //-----------------------------------
  // Pages
  //-----------------------------------
  Home.name,
  PhotosHomeLanding.name,
  Traffic.name,
  RegionSelectionLanding.name,
  WeatherHomeLanding.name,
  TrafficHomeLanding.name,
  EnlargedLivefeed.name,
  Videoplayer.name,
  ClosingsDelaysLanding.name,
  //-----------------------------------
  // Shared Components
  //-----------------------------------
  Button.name,
  HeaderMain.name,
  HeaderSecondary.name,
  Navbar.name,
  NavbarSubMenu.name,
  RegionSelection.name,
  LiveFeedVideo.name,
  StoryList.name,
  NewsTicker.name,
  Logo.name,
  OtherRegions.name,
  Poll.name,
  WeatherIcons.name,
  PhotoGallery.name,
  News12List.name,
  PhotoList.name,
  Archives.name,
  Ads.name,
  IncidentList.name,
  CameraList.name,
  CameraGallery.name,
  MapGallery.name,
  CameraGallery.name,
  Preroll.name
]);

export default componentModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/components.js
 **/